import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { downloadclassinvoice, getGBussinessInfo, getMemberTransactions, randomTid, saveTransaction, uploadInvoice } from '../../services/memberApiServices';
import '../styles/MemberBilling.css';
import { useCart } from './CartContext.js';
import PayNow from '../../components/class/payNow';
import Loader from '../../components/Loader';
import { MDBAlert, MDBBtn, MDBCol, MDBRow, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import BookingSuccess from '../../components/class/BookingSuccess';
import gymLogo from '../../components/images/Easy-MembrLogo.png';
import planing from "../../memberportal/assets/images/member.png";
import { useAnalytics } from '../../hooks/useAnalytics';


const MemberBillingPage = () => {
    const { state } = useLocation();
    const { trackButtonClick } = useAnalytics();
    const cartItems = state?.cartItems || [];
    const navigate = useNavigate();
    const {
        getMemberId,
        getGymId,
        clearCart
    } = useCart();
    console.log(cartItems, 'cartItems');
    const [itemStartDates, setItemStartDates] = useState(
        cartItems.reduce((dates, item) => {
            dates[item._id] = new Date().toISOString();
            return dates;
        }, {})
    );
    const [loader, setLoader] = useState(false)
    const [data, setData] = useState("");
    const [selItems, setSelItems] = useState(state?.cartItems || []);
    const [parentInfo, setParentInfo] = useState({
        name: '',
        number: '',
        email: ''
    });
    const [allData, setALLData] = useState([]);
    const [success, setSuccess] = useState(false)
    const handleStartDateChange = (itemId, date) => {
        setItemStartDates(prev => ({
            ...prev,
            [itemId]: date
        }));
    };
    const [tid, setTid] = useState('')
    const [payinfo, setPayinfo] = useState({})
    const [alertMsg, setAlertMsg] = useState({
        message: "",
        type: ""
    });

    useEffect(() => {
        async function fetchData() {
            if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
                navigate('/memberlogin', { state: { path: '/membershipplans' } })
                return
            }
            const response = await getGBussinessInfo(
                getGymId()
            );
            if (!response) return;
            if (response === "false") {
                // setApiError(true)
            } else {
                const record = await response.json();
                if (!record) return;
                setData(record);
            }

        }
        fetchData();
    }, []);
    useEffect(() => {
        async function fetchMemberData() {
            if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
                navigate('/memberlogin', { state: { path: '/membershipplans' } })
                return
            }
            const response = await getMemberTransactions(getMemberId());
            if (!response) {
                return;
            }
            if (response === "false") {
                // setApiError(true)
                return;
            }
            const membersData = await response.json();
            console.log(membersData);
            if (membersData && membersData.length > 0) {
                const update = {
                    name: membersData[0]?.fname ? membersData[0].fname + " " + membersData[0].lname : '',
                    number: membersData[0]?.number ? membersData[0].number : '',
                    email: membersData[0]?.email ? membersData[0].email : ""
                }
                console.log(update, 'updatemembername');

                setParentInfo(update)
            }
            setALLData(membersData);

        }

        fetchMemberData()
        generateToken()
    }, []);
    function decrementCount(price, included) {
        const taxamounts = []
        if (data && data.dgsttax[0] === 1) {
            taxamounts.push({
                percentage: '18%',
                title: 'GST',
                amount: parseFloat((price * 0.18).toFixed(2))
            });
        }

        if (data.ugsttax) {
            data.ugsttax.forEach((obj) => {
                if (obj.check) {
                    const percentageNumber = parseFloat(obj.label);
                    taxamounts.push({
                        percentage: `${percentageNumber}%`,
                        title: `${obj.title}`,
                        amount: parseFloat((price * (percentageNumber / 100)).toFixed(2))
                    });
                }
            });
        }

        taxamounts.push({ TaxCheck: included ? "Included" : "Excluded" });
        return taxamounts;
    }

    async function generateToken() {

        try {
            const response = await randomTid();
            if (!response || !response.ok) {
                console.error("Invalid or failed response.");
                //   setApiError(true);
                return;
            }
            const data = await response.json();

            if (!data || data === "false") {
                // setApiError(true);
                return;
            }
            const transactionId = data.id || data;

            if (transactionId) {
                setTid(transactionId)
            }
        } catch (error) {

            setTid(Math.random().toString().substring(2, 8))
            // console.error("Error generating token:", error);
        }
    }
    const formatCartData = (payinfo) => {
        const items = cartItems?.map(item => ({
            Item: { ...item },
            extendmember: [],
            idate: itemStartDates[item._id] || new Date().toISOString(),
            isplan: item.type === 'plan' ? 1 : 0,
            members: allData,
            quantity: 1,
            taxamounts: decrementCount(Number(item?.price ?? item?.props?.[0]?.propvalue ?? 0), item.taxcheck),
            _id: item._id
        }));

        const totalPrice = cartItems.reduce((sum, item) => sum + parseFloat(Number(item?.price ?? item?.props?.[0]?.propvalue ?? 0)), 0);

        return {
            items,
            paymentData: {
                PaymentLinkId: -1,
                balance: 0,
                parentname: parentInfo,
                payinfo: {
                    mode: -3,
                    balmode: 1,
                    info: {
                        cash_amt: '',
                        cc_amt: '',
                        upi_amt: '',
                        upi_input: '',
                        wallet_amt: ''
                    },
                    balance: 0,
                    razorpay: payinfo && payinfo !== null ? payinfo : {}
                },
                price: totalPrice.toFixed(2),
                tId: tid,
                token: -1,
                totalPrice: totalPrice.toFixed(2),
                transDate: new Date().toISOString(),
                razorpay: payinfo && payinfo !== null ? payinfo : {},
                transId: '',
                type: 1
            }
        };
    };
    console.log(cartItems.length, 'cartItems.length ');

    const handleSubmit = async (payinfo) => {
        setPayinfo(payinfo)
        const formattedData = formatCartData(payinfo);
        console.log('Data to send to backend:', formattedData);
        const update = {
            ...formattedData.items,
            ...formattedData.paymentData
        }
        console.log(update);

        try {
            console.log({ ...update, sId: getGymId(), tId: tid, gymid: getGymId() }, '9999999999999999999999')

            const saverep = await saveTransaction(
                { ...update, sId: getGymId(), tId: tid, gymid: getGymId() },
                getGymId(),
            );
            if (!saverep || !saverep.ok) {
                console.error("Invalid or failed response.");
                return;
            }
            const result = await saverep.json();
            console.log("saveTransaction999", result);

            if (!saverep || result === false) {
                return;
            }
            await trackButtonClick("MemberBillingpage", "Create_Membership_Transaction", "member", {});
            if (result?.message === "Transaction was already created") {
                setAlertMsg({
                    message: result.message,
                    type: "danger"
                })
                return;
            }
            const uploadsaverep = await uploadInvoice(
                { invoiceId: tid, Gid: getGymId(), url: window.location.origin },
                tid,
            );
            if (!uploadsaverep || uploadsaverep === false) {
                return;
            }
            const url = await uploadsaverep.json()
            console.log(url, 'url');
            if (cartItems.length > 1) {
                clearCart()
            }

            setAlertMsg({
                message: "Transaction created successfully",
                type: "success"
            })

        } catch (e) {
            console.log("Errore::::::::::::::::: " + e);
            setAlertMsg({
                message: "Something went wrong.",
                type: "danger"
            })
        }

        setLoader(false)
        setSuccess(true)
    };

    const calculateTaxes = () => {
        return cartItems.reduce((sum, item) => {
            const taxes = decrementCount(Number(item?.price ?? item?.props?.[0]?.propvalue ?? 0), item.taxcheck);
            const taxamount = taxes.reduce((taxSum, tax) => taxSum + (tax.amount || 0), 0)
            return sum + (item.taxcheck ? 0 : taxamount);
        }, 0);
    };

    const processing = async (data) => {
    }
    const callbackfunction = async (data) => {
        setLoader(true)
        await handleSubmit(data)
    }

    const userdetails = {
        name: parentInfo.name,
        email: parentInfo.email,
        contact: parentInfo.number
    }
    const homeCallback = () => {
        navigate("/membershipplans")
    }

    const downloadInvoice = async () => {
        try {

            const update = {
                tid: tid,
                bid: getGymId(),
                type: "membership"
            }
            console.log(update, 'update');
            if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
                navigate('/memberlogin', { state: { path: '/membershipplans' } })
                return
            }
            const response = await downloadclassinvoice(update, "user")

            const data = await response.json();
            console.log(data, "data");

            if (data.url) {
                const link = document.createElement("a");
                link.href = data.url;
                link.setAttribute("download", "filename.pdf");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error("Error fetching signed URL", error);
        }
    }
    return (
        <>
            {!success ? <>
                <div className='member-billing-wrapper'>

                    {loader ? <Loader /> : <div className="container member-billing-container">
                        <div className="member-billing-header">
                            <div className='text-left'>
                                <h5 className="member-billing-title mb-0">Billing Information</h5>
                                <span className='text-secondary'>Keeping Your Billing Simple and Clear</span>
                            </div>
                            <div>
                                <img
                                    src={gymLogo}
                                    className='billing-logo'
                                    alt="Gym Logo" />
                            </div>
                        </div>

                        <div className="member-billing-content">
                            <div className="member-billing-card member-parent-info">
                                <p className="mb-2 fw-bold label-color">Parent/Guardian Information</p>
                                <div className='row'>
                                    <div className="col-12 col-md-6 mb-3">
                                        <label className="form-label mb-1">Full Name</label>
                                        <input
                                            type="text"
                                            class="form-control form-control-lg"
                                            placeholder='Enter Full Name'
                                            value={parentInfo.name}
                                            onChange={(e) => setParentInfo({ ...parentInfo, name: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6 mb-3">
                                        <label className="form-label mb-1">Phone Number</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-lg"
                                            placeholder='Enter Phone Number'
                                            value={parentInfo.number}
                                            onChange={(e) => setParentInfo({ ...parentInfo, number: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6 mb-4">
                                        <label className="form-label mb-1">E-mail Id</label>
                                        <input
                                            type="email"
                                            className="form-control form-control-lg"
                                            placeholder='Enter E-mail id'
                                            value={parentInfo.email}
                                            onChange={(e) => setParentInfo({ ...parentInfo, email: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='summary_content mt-2'>
                                <MDBRow>
                                    <MDBCol size={12} md={8}>
                                        <MDBRow>
                                            <MDBCol size={12}>
                                                <p className="mb-2 fw-bold label-color">Order Summary</p>
                                            </MDBCol>
                                            <MDBCol sm={12} md={12}>
                                                <MDBTable className="summary_tabel" responsive>
                                                    <MDBTableHead>
                                                        <tr>
                                                            <th scope='col'>Plan Details</th>
                                                            <th scope='col'>Start Date</th>
                                                            <th scope='col'>Valid for</th>
                                                            <th scope='col'>Price</th>
                                                        </tr>
                                                    </MDBTableHead>
                                                    <MDBTableBody>
                                                        {cartItems.map((item) => (
                                                            <tr key={item._id}>
                                                                <td scope='row'>
                                                                    <div className="plan_content d-flex align-items-center">
                                                                        <div className="plan_pic me-2">
                                                                            <img src={planing} alt="" />
                                                                        </div>
                                                                        <div className="tagname">
                                                                            <p className="m-0"><span>{item.displayName ? item.displayName : item.name}</span>  <span className="member-pan-badge">{item.type === 'plan' ? 'Plan' : 'Addon'}</span>
                                                                            </p>
                                                                            <span className="text-secondary">Energize your every move.</span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>  <input
                                                                    type="datetime-local"
                                                                    className="form-control date-custom"
                                                                    style={{ width: '160px' }}
                                                                    value={itemStartDates[item._id]?.slice(0, 16) || ''}
                                                                    onChange={(e) => handleStartDateChange(item._id, e.target.value)}
                                                                /></td>
                                                                <td>{item.numberofdays} days</td>
                                                                <td align='right'>₹ {Number(item?.price ?? item?.props?.[0]?.propvalue ?? 0).toLocaleString('en-IN')}</td>
                                                            </tr>
                                                        ))}
                                                    </MDBTableBody>
                                                </MDBTable>
                                            </MDBCol>
                                        </MDBRow>
                                    </MDBCol>
                                    <MDBCol size={12} md={4}>
                                        <MDBRow>
                                            <MDBCol size={12}>
                                                <p className="mb-2 fw-bold label-color">Payment Summary</p>
                                            </MDBCol>
                                            <MDBCol sm={12} md={12}>
                                                <div className="paysummary p-3 rounded-4">
                                                    <div className="member-summary-row">
                                                        <span>Subtotal </span>
                                                        <span>₹{(cartItems.reduce((sum, item) => sum + parseFloat(Number(item?.price ?? item?.props?.[0]?.propvalue ?? 0)), 0).toFixed(2)).toLocaleString('en-IN')}</span>
                                                    </div>
                                                    <div className="member-summary-row">
                                                        <span>Taxes</span>
                                                        <span>₹{calculateTaxes().toFixed(2)}</span>
                                                    </div>
                                                    <div className="member-summary-row member-total-row">
                                                        <span>Total</span>
                                                        <span>₹{((cartItems.reduce((sum, item) => sum + parseFloat(Number(item?.price ?? item?.props?.[0]?.propvalue ?? 0)), 0) + calculateTaxes()).toFixed(2)).toLocaleString('en-IN')}</span>
                                                    </div>
                                                    <div className='text-end mt-2'>
                                                        <MDBBtn color='secondary' className="me-3 fw-bold" onClick={() => { navigate("/membershipplans") }}>Cancel</MDBBtn>
                                                        <PayNow
                                                            amount={(cartItems.reduce((sum, item) => sum + parseFloat(Number(item?.price ?? item?.props?.[0]?.propvalue ?? 0)), 0) + calculateTaxes()).toFixed(2)}
                                                            callback={callbackfunction}
                                                            gymid={getGymId()}
                                                            user={userdetails}
                                                            processing={processing}
                                                            from="Membership"
                                                            title={"Proceed to Pay"}
                                                        />

                                                    </div>
                                                </div>
                                            </MDBCol>
                                        </MDBRow>
                                    </MDBCol>
                                </MDBRow>
                            </div>

                        </div>
                    </div>}
                </div>
            </> : <>
                <BookingSuccess homeCallback={homeCallback} trans={payinfo} downloadInvoice={downloadInvoice} />
            </>}
            <MDBAlert
                color={alertMsg.type}
                autohide
                position="top-right"
                delay={3000}
                appendToBody
                open={alertMsg.message !== ""}
                onClose={() => setAlertMsg({
                    message: "",
                    type: ""
                })}
            >
                {alertMsg.message}
            </MDBAlert>
        </>

    );
};

export default MemberBillingPage;